
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/other-resources-by-state",
      function () {
        return require("private-next-pages/resources/other-resources-by-state.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/other-resources-by-state"])
      });
    }
  